import { render, staticRenderFns } from "./GeneralSplitter.vue?vue&type=template&id=7d630247&scoped=true&"
import script from "./GeneralSplitter.vue?vue&type=script&lang=js&"
export * from "./GeneralSplitter.vue?vue&type=script&lang=js&"
import style0 from "./GeneralSplitter.vue?vue&type=style&index=0&id=7d630247&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d630247",
  null
  
)

export default component.exports